export const TARGET_KM = 650;
export const TARGET_DATE = new Date('2026-02-25');
export const TARGET_DATE_TIME = new Date('2026-02-25T19:00:00');
export const START_DATE = new Date('2025-11-19');

export const MILESTONES = [
  { km: 50, emoji: '🥉', label: 'Bronze', color: '#cd7f32' },
  { km: 100, emoji: '🥈', label: 'Silber', color: '#c0c0c0' },
  { km: 200, emoji: '🥇', label: 'Gold', color: '#ffd700' }
];
